import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = true

export default {
  namespaced,
  state: {
    summary: {
      payments: {
        saldo: '',
        payout_possibility: false
      },
      calculations: { },
      pending: false
    },
    history: {
      pending: false
    }
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/index.js